<template>
  <div id="timeline">
    <!-- <header>{{ $t('title.timeline') }}</header> -->
    <div ref="timelinePresenter"></div>
  </div>
</template>

<script>
  import vis from 'vis'

  export default {
    name: 'timeline',
    props: {
      chapter: Object,
      language: String
    },
    data() {
      return {
        timeline: null,
        articles: [],
        items: null
      }
    },
    mounted: function () {
      var container = this.$refs['timelinePresenter']
      this.items = new vis.DataSet([])
      var options = {
        zoomable: false,
        align: 'left',
        margin: {
          item: { vertical: 0 },
          axis: 0
        },
        timeAxis: { scale: 'day', step: 7 },
        orientation: { axis: 'top', item: 'top' },
        order: function(left, right) {
          return new Date(left.publishDate) > new Date(right.publishDate) ? left : right
        }
      }
      this.timeline = new vis.Timeline(container, this.items, options)
      this.timeline.on('select', this.selectArticle)
      this.getArticles()
    },
    watch: {
      chapter: function () {
        this.getArticles()
      },
      language: function () {
        this.getArticles()
      }
    },
    methods: {
      getArticles: function (success, fail) {
        if (!this.chapter) { return }
        this.$http.get('chapters/' + this.chapter.id + '/articles?lang=' + this.$lang)
          .then(response => {
            this.setUpItemsWith(response.body)
          }, response => {
            console.error(response.body)
            this.items.clear()
          })
      },
      setUpItemsWith: function(articles) {
        for (let article of articles) {
          article.content = '<div class="timeline-item"> ' +
                              '<div class="item-icon"><i class="fa ' + this.getIconForArticleType(article.articleType.name) + '"></i></div>' +
                              // '<div class="item-content">' +
                              //   '<div class="item-title">' + article.articleTranslations[0].title + '</div>' +
                              //   '<div class="item-subtitle">' + article.articleTranslations[0].description + '</div>' +
                              // '</div>' +
                            '</div>'
          article.start = new Date(article.publishDate)
          article.title = article.articleTranslations[0].title + '<br/>' + this.formatDate(article.publishDate)
        }

        this.articles = articles

        this.items.clear()
        this.items.add(this.articles)

        this.timeline.setItems(this.items)
        this.timeline.fit()
      },
      selectArticle: function(properties) {
        console.log(properties.items)
        if (properties.items[0]) {
          this.$parent.$emit('articleSelected', properties.items[0])
        }
      }
    }
  }

</script>

<style lang="scss">
  @import "../../../node_modules/vis/dist/vis.css";
  @import "~styles/_vars.scss";

  #timeline {
    header {
      text-align: center;
      text-transform: uppercase;
      letter-spacing: 6px;
      font-weight: $semibold;
      color: #c0c0c0;
      font-size: 0.75rem;
      padding: 0.75rem;
      background: $bg-timeline;

      @media (max-width: $device-sm) {
        padding: 0.5rem;
      }
    }
  }

  .vis-timeline {
    border-top: 1px solid $border-timeline;
    border-bottom: 1px solid $border-timeline;

    .vis-panel.vis-center {
      border: 1px solid $light-gray;
    }

    .vis-current-time {
      background-color: $primary-color;
    }

    .vis-time-axis {
      background: $white;

      &.vis-foreground {
        background: $bg-timeline;
      }

      .vis-text {
      color: $txt-color-secondary;
      font-size: 0.75rem;

        &.vis-major {
          color: $txt-color-heading !important;
          font-weight: $semibold;
          font-size: 0.85rem;
        }
      }
    }

    .vis-item {
      border: none;
      background: none;

      .vis-dot {
        border: none;
      }

      .vis-item-content {
        padding: 0;

        .timeline-item {
          display: table;
          border-radius: $border-radius-standard;
          // box-shadow: 0 1px 6px rgba(0, 0, 0, 0.1);
          transition: all 0.2s;
          // border: 1px solid #e6e6e6;
          cursor: pointer;

          &:hover {
            // border-color: $border-timeline;
            // box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
            transform: scale(1.2, 1.2);
          }

          .item-icon, .item-content {
            display: table-cell;
            vertical-align: middle;
            padding: 0;
          }

          .item-icon {
            text-align: center;
            padding: 0;
            // border-right: 1px solid $light-gray;
            font-size: 1.4rem;
            color: $primary-color;
          }

          .item-content {
            text-align: left;

            .item-title {
              font-weight: $semibold;
              font-size: 0.9rem;
            }

            .item-subtitle {
              font-size: 0.8rem;
              color: $txt-color-secondary;
            }
          }
        }
      }
    }

  }

</style>



// WEBPACK FOOTER //
// Timeline.vue?23608cdc